import Vue from 'vue'
import ElementUI from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import { formatDate } from '@/utils/enum'
// import 'bootstrap/dist/css/bootstrap.css'
// import './assets/css/style.css'
// import './assets/css/responsive.css'

Vue.config.productionTip = false
Vue.use(ElementUI)

// 轉換千分位
Vue.filter('currency', function(value) {
  if (!value) return ''
  return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})
Vue.filter('formatDate', function(date, fmt) {
  return formatDate(date, fmt)
})

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
